import * as React from "react"

/*
 * 1024, not shadcn's 768 — the app's own `lg`, where the bottom bar gives way
 * to the rail.
 *
 * At 768 the two disagreed: between 768 and 1023 the sidebar drew its desktop
 * rail while the shell still showed the phone's bottom bar and header, so a
 * tablet got both navigations and the rail's gap beside the content. Below
 * `lg` the rail is now the sheet the header's menu button opens.
 */
const MOBILE_BREAKPOINT = 1024

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    }
    mql.addEventListener("change", onChange)
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    return () => mql.removeEventListener("change", onChange)
  }, [])

  return !!isMobile
}
